import { render, staticRenderFns } from "./contentUserGroupMove.vue?vue&type=template&id=23dec35e&"
import script from "./contentUserGroupMove.vue?vue&type=script&lang=js&"
export * from "./contentUserGroupMove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports